const ImageBoxBlockIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
  >
    <path fill="#333" d="M0 18h24v2H0zM0 22h24v2H0z" />
    <path fill="#ffd400" d="M2 2h20v10H2z" />
    <path d="M22 2v10H2V2h20m2-2H0v14h24V0z" fill="#333" />
    <path fill="#fff" d="M2 2h10v10H2z" />
    <circle cx="6" cy="6" r="2" fill="#333" />
  </svg>
);

export default ImageBoxBlockIcon;
